import {
  IncomingCreatePrePurchaseFormDto,
  IncomingCreatePrePurchaseResponseDto,
  IncomingUpdatePrePurchaseFormDto,
  IncomingUpdatePrePurchaseResponseDto,
  OutgoingPrePurchaseFormDto,
  OutgoingPrePurchaseResponseDto
} from 'api/dtos/events/pre-purchase-questions';
import bounceApiClient from 'legacy/common/utils/bounceApiClient';

export async function createPrePurchaseForm({
  eventId,
  schema
}: {
  eventId: string;
  schema: IncomingCreatePrePurchaseFormDto;
}): Promise<OutgoingPrePurchaseFormDto> {
  const { data } = await bounceApiClient.post(
    `/api/events/${eventId}/pre-purchase-questions`,
    { schema }
  );

  return data;
}

export async function updatePrePurchaseForm({
  eventId,
  schema
}: {
  eventId: string;
  schema: IncomingUpdatePrePurchaseFormDto;
}): Promise<OutgoingPrePurchaseFormDto> {
  const { data } = await bounceApiClient.put(
    `/api/events/${eventId}/pre-purchase-questions`,
    { schema }
  );

  return data;
}

export async function createPrePurchaseResponse({
  eventId,
  response
}: {
  eventId: string;
  response: IncomingCreatePrePurchaseResponseDto;
}): Promise<OutgoingPrePurchaseResponseDto> {
  const { data } = await bounceApiClient.post(
    `/api/users/me/events/${eventId}/pre-purchase-questions/responses`,
    response
  );

  return data;
}

export async function updatePrePurchaseResponse({
  eventId,
  response
}: {
  eventId: string;
  response: IncomingUpdatePrePurchaseResponseDto;
}): Promise<OutgoingPrePurchaseResponseDto> {
  const { data } = await bounceApiClient.put(
    `/api/users/me/events/${eventId}/pre-purchase-questions/responses`,
    response
  );

  return data;
}

export async function getPrePurchaseForm(
  eventId: string
): Promise<OutgoingPrePurchaseFormDto> {
  const { data } = await bounceApiClient.get(
    `/api/events/${eventId}/pre-purchase-questions`
  );

  return data;
}

export async function getPrePurchaseResponse(
  eventId: string
): Promise<OutgoingPrePurchaseResponseDto> {
  const { data } = await bounceApiClient.get(
    `/api/users/me/events/${eventId}/pre-purchase-questions/responses`
  );

  return data;
}

export async function deletePrePurchaseForm(
  eventId: string
): Promise<{ success: boolean }> {
  const { data } = await bounceApiClient.delete(
    `/api/events/${eventId}/pre-purchase-questions`
  );
  return data;
}
